import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getFilteredPermissionData } from '..';
import { ComponentsNames } from '../../constants/innerRoutesList';
import { selectAuthRoutesList } from '../../pages/configuration/routeSlice';
import { type ModalStatusType } from '../../types/common';

export interface PermissionProps {
  type: ModalStatusType;
  permission: string;
  feature: 'Customer' | 'Vendor';
}

const builder = (props: PermissionProps) => {
  const { type, permission, feature } = props;
  let finalPermission = `CustomerService.${feature}.${permission}`;
  if (type !== 'View') {
    finalPermission += `.${type}`;
  }
  return finalPermission;
};

const permissionCheck = (props: PermissionProps): boolean => {
  // const location = useLocation();
  // const url = location.pathname.split('/');
  // const userAuthList = useSelector(selectAuthRoutesList);
  // const { nonFieldLevelPermissionsGroups } = getFilteredPermissionData(
  //   userAuthList?.auth?.grantedPolicies ?? {}
  // );

  // const getUrlName =
  //   urlName != null && urlName !== ''
  //     ? ComponentsNames?.find((item) => item.url === urlName)?.name
  //     : ComponentsNames?.find((item) => item.url === url[url.length - 1])?.name;

  // const hasPermission =
  //   getUrlName != null &&
  //   getUrlName !== '' &&
  //   nonFieldLevelPermissionsGroups[getUrlName]?.some((item: any) => item.text === type);

  // return Boolean(hasPermission);
  const userAuthList = useSelector(selectAuthRoutesList);
  const policies = userAuthList?.auth?.grantedPolicies;
  const permission = builder(props);

  if (policies?.[permission]) return true;

  return false;
};

export default permissionCheck;
